import React, { useState } from 'react';
import { testimonials } from '../data/content';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const prev = () => setI((i - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((i + 1) % testimonials.length);

  return (
    <section id="testimonials" className="relative py-24 lg:py-36 bg-[#E3DBD1] border-y border-[#d9d2ca]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-4" data-reveal>
            <p className="sec-num text-sm tracking-[0.3em] uppercase">/ 07</p>
            <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#7a7369]">Success case</p>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-serif text-[32px] lg:text-[52px] leading-[1.05] tracking-[-0.015em] text-[#2E2C28] font-light" data-reveal style={{ '--reveal-delay': '120ms' }}>
              What founders <span className="italic text-[#B5876C]">say</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 min-h-[340px]">
          <div className="lg:col-span-2 hidden lg:block" data-reveal="fade">
            <span aria-hidden className="font-serif text-[180px] leading-none text-[#B5876C]/30 select-none">“</span>
          </div>
          <div className="lg:col-span-9">
            <blockquote key={i} className="reveal">
              <p className="font-serif text-2xl md:text-3xl lg:text-[38px] leading-[1.35] text-[#2E2C28] font-light italic">
                {t.quote}
              </p>
              <footer className="mt-10 flex items-center gap-4">
                <div className="w-12 h-px bg-[#B5876C]" />
                <div>
                  <p className="text-sm tracking-[0.16em] uppercase text-[#2E2C28] font-medium">{t.author}</p>
                  {t.org && <p className="text-xs tracking-[0.2em] uppercase text-[#7a7369] mt-1">{t.org}</p>}
                </div>
              </footer>
            </blockquote>
          </div>
        </div>

        <div className="mt-16 flex items-center justify-between border-t border-[#d9d2ca] pt-8" data-reveal="fade">
          <p className="text-[11px] tracking-[0.24em] uppercase text-[#7a7369]">{String(i + 1).padStart(2, '0')} / {String(testimonials.length).padStart(2, '0')}</p>
          <div className="flex items-center gap-3">
            <button onClick={prev} aria-label="Previous testimonial" className="press w-11 h-11 border border-[#B5876C]/40 hover:bg-[#B5876C] hover:text-[#EBE4DE] text-[#2E2C28] flex items-center justify-center transition-colors duration-300">
              <ArrowLeft size={16} strokeWidth={1.5} />
            </button>
            <button onClick={next} aria-label="Next testimonial" className="press w-11 h-11 border border-[#B5876C]/40 hover:bg-[#B5876C] hover:text-[#EBE4DE] text-[#2E2C28] flex items-center justify-center transition-colors duration-300">
              <ArrowRight size={16} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
